import React, { ReactNode } from "react";

export type WhenProps =
  | { isTrue: boolean; isFalse?: never; children: ReactNode }
  | { isTrue?: never; isFalse: boolean; children: ReactNode };

const When: React.FC<WhenProps> = (props) => {
  if ("isTrue" in props && props.isTrue) {
    return <>{props.children}</>;
  } else if ("isFalse" in props && !props.isFalse) {
    return <>{props.children}</>;
  }
  return null;
};

export { When };
